import {IconNames} from '@blueprintjs/icons';

import {slackIcon, awsS3Icon, gdriveIcon} from '../../shared/utils/custom-icons';
import {getIconFor} from '../../shared/utils/custom-icons';
import {renderSelectAll} from './components/SelectAll';

export const REPORT_COLUMNS = {
  select: {
    id: 'select',
    show_in_table: true,
    sortable: false,
    label: renderSelectAll(),
    width: '3%',
    minWidth: '30px',
  },
  name: {
    id: 'name',
    show_in_table: true,
    sortable: false,
    label: 'Report',
    width: '24%'
  },
  folder: {
    id: 'folder',
    show_in_table: true,
    sortable: false,
    label: 'Folder',
    width: '6%'
  },
  workflow: {
    id: 'workflow',
    show_in_table: true,
    sortable: false,
    label: 'Schedule',
    width: '16%'
  },
  last_run: {
    id: 'last_run',
    show_in_table: true,
    sortable: false,
    label: 'Last Runs',
    width: '14%'
  },
  next_run: {
    id: 'next_run',
    show_in_table: true,
    sortable: false,
    label: 'Next Run',
    width: '13%'
  },
  tags: {
    id: 'tags',
    show_in_table: true,
    sortable: false,
    label: 'Tags',
    width: '8%'
  },
  action: {
    id: 'action',
    show_in_table: true,
    sortable: false,
    label: '',
    width: '16%'
  }
};

export enum REPORT_TYPE {
  ALL = '',
  REPORT = 'default',
  NOTEBOOK = 'notebook',
  TABLEAU_EMBED = 'tableau_embed',
}

export enum RowAction {
  DELETE = 'DELETE',
  DUPLICATE = 'DUPLICATE',
  EDIT = 'EDIT',
  RUN = 'RUN',
  OPEN_IN_NEW_TAB = 'OPEN_IN_NEW_TAB',
}

export enum DESTINATION {
  EMAIL = 'email',
  SLACK = 'slack',
  SFTP = 'sftp',
  AWS_S3 = 'aws_s3',
  GDRIVE = 'gdrive',
}

export enum CONTENT_TYPE {
  CODE_BLOCK = 'code_block',
  KPI_CARD = 'kpi_card',
  PARAGRAPH = 'p',
  SQL = 'sql',
  TABLEAU = 'tableau',
  EXTERNAL_FILE = 'external_file',
}

const slackIconProps = {
  width: 16,
  height: 16,
  viewBoxDefault: '0 0 24 24',
};

const customIconProps = {
  width: 16,
  height: 16,
}

const awsS3IconProps = {
  width: 24,
  height: 24,
  viewBoxDefault: '0 0 512 512',
}

const gdriveIconProps = {
  width: 24,
  height: 24,
  viewBoxDefault: '0 0 24 24',
}

export const DESTINATION_OPTIONS = [
  {value: DESTINATION.EMAIL, label: 'Email', icon: IconNames.ENVELOPE},
  {value: DESTINATION.SLACK, label: 'Slack', icon: slackIcon(slackIconProps)},
  {value: DESTINATION.SFTP, label: 'SFTP', icon: IconNames.CLOUD_UPLOAD},
  {value: DESTINATION.AWS_S3, label: 'AWS S3', icon: awsS3Icon(awsS3IconProps)},
  {value: DESTINATION.GDRIVE, label: 'GDRIVE', icon: gdriveIcon(gdriveIconProps)},
];

export const CONTENT_TYPE_OPTIONS = [
  {value: CONTENT_TYPE.SQL, label: 'SQL Query', icon: getIconFor(CONTENT_TYPE.SQL, customIconProps)},
  {value: CONTENT_TYPE.TABLEAU, label: 'Tableau Export', icon: getIconFor(CONTENT_TYPE.TABLEAU, customIconProps)},
  {value: CONTENT_TYPE.KPI_CARD, label: 'KPI Card', icon: IconNames.CHART},
  {value: CONTENT_TYPE.EXTERNAL_FILE, label: 'External File', icon: IconNames.DOCUMENT},
]

/*
 * Time in ms to autosave report
 */
export const AUTOSAVE_TIME: number = 1500;

export enum MAIL_MERGE_SOURCE {
  NONE = 'none',
  JSON = 'json',
  SQL = 'sql',
  TABLEAU = 'tableau', // view_csv
}

export const MAIL_MERGE_SOURCE_OPTIONS = [
  {value: MAIL_MERGE_SOURCE.JSON, label: 'Manual Input', icon: IconNames.ARRAY},
  {value: MAIL_MERGE_SOURCE.SQL, label: 'SQL Query', icon: IconNames.DATABASE},
  {value: MAIL_MERGE_SOURCE.TABLEAU, label: 'Tableau', icon: getIconFor(CONTENT_TYPE.TABLEAU, customIconProps)},
];

export enum CONDITION_SOURCE {
  NONE = 'none',
  SQL = 'sql',
}

export enum CONDITION_CHECK_TYPE {
  TRUE = 'true',
  FALSE = 'false',
  ANY = 'any'
}
